export default __webpack_public_path__ + "6354033e7cb5fbdf0dfdf2bf589afc12.png";